module.exports = __webpack_public_path__ + "static/media/rannee.75748ff4.jpg";